import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { InsertScrewFamilyBody, SearchScrewFamiliesResponse, UpdateScrewFamilyBody } from "./types/screwFamilies";

export const useDeckScrewFamiliesApi = () => {
  const crud = createAdminCrudApi<SearchScrewFamiliesResponse, InsertScrewFamilyBody, UpdateScrewFamilyBody>(
    useApi(),
    DECK_ADMIN_URL,
    "screw_families",
  );

  return {
    useDeckScrewFamilies: crud.useSearch,
    getDeckScrewFamilies: crud.search,
    insertDeckScrewFamily: crud.insert,
    updateDeckScrewFamily: crud.update,
    deleteDeckScrewFamily: crud.remove,
    updateDeckScrewFamilyVisibility: crud.updateVisibility,
    updateDeckScrewFamilyOrder: crud.updateOrder,
  };
};

export default useDeckScrewFamiliesApi;
